// extracted by mini-css-extract-plugin
export var quillEditor = "_je-1";
export var variable = "_je-0";